import React from 'react';
import { ShieldAlert } from 'lucide-react';

const NoAccessPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-gray-800 px-4">
      <div className="p-8 max-w-md w-full text-center">
        <ShieldAlert className="text-red-500 w-12 h-12 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-red-600">접근 권한 없음</h1>
        <p className="mt-3 text-sm text-gray-600">
          이 페이지는 관리자 전용입니다.
          <br />
          권한이 없는 사용자는 접근할 수 없습니다.
        </p>
        <a
          href="/"
          className="mt-6 inline-block px-3 py-2 bg-sky-500 text-white rounded-xl shadow hover:bg-sky-600 transition">
          메인으로 돌아가기
        </a>
      </div>
    </div>
  );
};

export default NoAccessPage;
